import React from 'react';

const variants = {
  default: 'sp-badge',
  success: 'sp-badge sp-badge--active',
  warning: 'sp-badge sp-badge--review',
  danger: 'sp-badge sp-badge--flag',
  info: 'sp-badge',
  critical: 'sp-badge sp-badge--risk-critical',
  high: 'sp-badge sp-badge--risk-high',
  medium: 'sp-badge sp-badge--risk-medium',
  low: 'sp-badge sp-badge--risk-low',
  active: 'sp-badge sp-badge--active',
  inactive: 'sp-badge sp-badge--inactive',
  monitoring: 'sp-badge sp-badge--review',
  closed: 'sp-badge sp-badge--inactive',
  resolved: 'sp-badge sp-badge--inactive',
  expiring: 'sp-badge sp-badge--review',
  valid: 'sp-badge sp-badge--active',
  maintenance: 'sp-badge sp-badge--inactive',
  checked_out: 'sp-badge sp-badge--review',
  available: 'sp-badge sp-badge--active',
  review: 'sp-badge sp-badge--review'
};

export default function Badge({ children, variant = 'default', className = '' }) {
  return (
    <span className={`${variants[variant] || variants.default} ${className}`}>
      {children}
    </span>
  );
}
